import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import CaseStudies, { WORK_FILTERS, useWorkItems } from '../components/site/CaseStudies';
import { PageHero, PageShell, QuoteBand } from '../components/site/PageParts';
import useSeo from '../hooks/useSeo';

export default function Work() {
  const [params] = useSearchParams();
  const active = WORK_FILTERS.some((f) => f.key === params.get('type')) ? params.get('type') : 'all';
  const items = useWorkItems().filter((p) => active === 'all' || p.kind === active);
  useSeo({
    title: 'Work | Merch Production & Live Printing Projects | Pusha Teez',
    description: 'Projects by Pusha Teez — merch production, tee designs and live printing work for artists, brands and events.',
    path: '/work',
  });
  return (
    <PageShell testid="work-page">
      <PageHero eyebrow="Our work" title="The" accent="Work" intro="A look at merch we've produced and live printing projects we've run. Filter by type below.">
        <div className="flex flex-wrap gap-3 mt-10" role="tablist" data-testid="work-filter">
          {WORK_FILTERS.map((f) => (
            <Link
              key={f.key}
              to={f.key === 'all' ? '/work' : `/work?type=${f.key}`}
              role="tab"
              aria-selected={active === f.key}
              className={`rounded-full px-5 py-2.5 text-sm font-semibold border transition-colors duration-200 ${
                active === f.key ? 'bg-[#00b8ff] text-black border-[#00b8ff]' : 'border-white/15 text-[#f4efe6] hover:border-[#00b8ff]'
              }`}
              data-testid={`work-filter-${f.key}`}
            >
              {f.label}
            </Link>
          ))}
        </div>
      </PageHero>
      <CaseStudies items={items} title={null} />
      <QuoteBand title="Have a project in mind?" />
    </PageShell>
  );
}
